import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-product-composition',
  templateUrl: './product-composition.component.html',
  styleUrls: ['./product-composition.component.css']
})
export class ProductCompositionComponent implements OnInit, OnChanges {
  
  @Input() isEdit: boolean = false;
  @Input() editData: any = null;
  @Output() onSave = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }
  amount:any = 0
  cProductList: any[] = [];
  cProductListFilter: any[] = [];
  notification:any = ['']
  page:number = 1;
  count:number = 0;
  tableSize:number = 10;
  tableSizes:any = [3, 6, 9, 12];
  cid:any;
  uomData:any = [];
  productName:any = ""
  batchPrice:any = ""
  batchQuantity:any = ""
  isDefault:any = ""
  done:any = [];

  searchBoxTxt: string = '';

  uomDropdownList:any = [];
  uomSelectedList:any = [];
  uomDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'uomMasterId',
    textField: 'uomName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    this.getAllUomMaster()
    this.getAllCProduct()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editData'] && this.editData) {
      this.populateEditData();
    }
  }

  populateEditData() {
    this.productName = this.editData.productName;
    this.batchPrice = this.editData.batchPrice;
    this.batchQuantity = this.editData.batchQuantity;
    this.amount = this.editData.totalAmount || 0;
    this.done = JSON.parse(JSON.stringify(this.editData.productCompositionIngList));
    
    this.uomSelectedList = [];
    if (this.editData.supportedUOMObjList) {
      for (let i = 0; i < this.editData.supportedUOMObjList.length; i++) {
        this.uomSelectedList.push({
          "uomMasterId": this.editData.supportedUOMObjList[i].uomId,
          "uomName": this.editData.supportedUOMObjList[i].uomName
        });
        if (this.editData.supportedUOMObjList[i].isDefault) {
          this.isDefault = this.editData.supportedUOMObjList[i].uomId;
        }
      }
    }
    
    // Recalculate amount and filter available products
    this.amountChanged();
    this.filterProducts();
  }

  cancel() {
    this.onCancel.emit();
  }

  onItemSelect(item: any) {
    console.log(item);
  }

  onSelectAll(items: any) {
    console.log(items);
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      
      this.filterProducts();
    }
    
    // Ensure all items in the raw material list have qty=1
    for(let i=0; i<this.cProductListFilter.length; i++){
      this.cProductListFilter[i].qty = 1;
    }
    
    this.amountChanged();
  }

  filterProducts() {
    const availableProducts = this.cProductList.filter(
      (product: any) => !this.done.some((doneItem: any) => doneItem.name === product.name)
    );

    if (this.searchBoxTxt) {
      const lowerTxt = this.searchBoxTxt.toLowerCase();
      this.cProductListFilter = availableProducts.filter((item: any) => 
        item.name.toLowerCase().includes(lowerTxt)
      );
    } else {
      this.cProductListFilter = availableProducts;
    }
  }

  addItem(item: any, index: number) {
    this.done.push(item);
    
    // Ensure default quantity
    item.qty = 1;
    
    this.filterProducts();
    this.amountChanged();
  }

  removeItem(item: any, index: number) {
    this.done.splice(index, 1);
    this.filterProducts();
    this.amountChanged();
  }

  amountChanged(){
    this.amount = 0
    for(let i=0; i<this.done.length;i++){
      console.log(this.done[i].price)
      if(this.done[i].price != 0){
        this.amount += Number(this.done[i].price) * Number(this.done[i].qty)
      }
    }
  }

  uomChange(event:any,index:any){
    console.log(index)
    console.log(event)
    for(let i = 0;i<this.done[index].supportedUOM.length;i++){
      if(this.done[index].supportedUOM[i].uomName == event.target.value){
        this.done[index].price = this.done[index].supportedUOM[i].price
      }
    }
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        console.log(res)
        this.uomDropdownList = res.response
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getAllCProduct(){
    this.generic_service.getAllcProductMaster().subscribe(
      (response:any)=>{
        console.log(response);
        this.cProductList = [];

        for(let i=0; i<response.response.length;i++){
          let body = {
            "name": String(response.response[i].name),
            "qty": 1,
            "uom": "",
            "price": 0,
            "supportedUOM": response.response[i].supportedUOM
          }

          if(response.response[i].supportedUOM != null && response.response[i].supportedUOM != undefined){
            for(let j=0;j<response.response[i].supportedUOM.length;j++){
              if(response.response[i].supportedUOM[j].isDefault == true){
                body.uom = response.response[i].supportedUOM[j].uomName
                body.price = response.response[i].supportedUOM[j].price
              }
            }
          }
    
          this.cProductList.push(body)
        }
        console.log(this.cProductList)
        this.filterProducts();
      }
    )
  }

  save() {
    let supportedUOMObjList: any = [];

    for (let j = 0; j < this.uomSelectedList.length; j++) {
      for (let i = 0; i < this.uomDropdownList.length; i++) {
        if (this.uomSelectedList[j].uomMasterId == this.uomDropdownList[i].uomMasterId) {
          supportedUOMObjList.push({
            "uomId": this.uomDropdownList[i].uomMasterId,
            "uomName": this.uomDropdownList[i].uomName,
            "cid": this.uomDropdownList[i].cid,
            "isDefault": this.uomSelectedList[j].uomMasterId == this.isDefault
          });
        }
      }
    }

    const ingredients = this.done.map((item: any) => {
      const { supportedUOM, ...rest } = item;
      return rest;
    });

    let body = {
      "version": this.isEdit ? this.editData.version : 0,
      "isActive": true,
      "description": "",
      "productCompositionId": this.isEdit ? this.editData.productCompositionId : 0,
      "productName": String(this.productName),
      "batchPrice": Number(this.batchPrice),
      "batchQuantity": Number(this.batchQuantity),
      "totalAmount": Number(this.amount),
      "supportedUOMObjList": supportedUOMObjList,
      "productCompositionIngList": ingredients,
      "cid": Number(this.cid)
    };

    if (this.isEdit) {
      this.generic_service.updateProdcutComposition(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.onSave.emit();
        },
        (error: any) => {
          this.toastr.error(error.error.errors[0].description);
        }
      );
    } else {
      this.generic_service.addProductComposition(body).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.resetForm();
          this.onSave.emit();
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  resetForm() {
    this.productName = "";
    this.batchQuantity = "";
    this.batchPrice = "";
    this.isDefault = "";
    this.done = [];
    this.amount = 0;
    this.uomSelectedList = [];
    this.filterProducts();
  } 

  enforcePositiveNumber(event: any) {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
  }

}
